import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authApi } from '../api/authApi';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const response = await authApi.login(username, password);
    
    if (response.success && response.accessToken && response.refreshToken) {
      login(response.accessToken, response.refreshToken);
      
      // Перезагружаем страницу для обновления всех данных
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      setError(response.message || 'Ошибка входа');
    }
  };

  return (
    <article className="mx-auto h-[calc(100vh-190px)] flex items-center justify-center w-0 flex-1 flex-col gap-6 py-10">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow">
        <div>
          <p className="mt-6 text-center text-base font-light text-gray-600">
            Вход в личный кабинет <span className="font-medium">parallel.one</span>
          </p>
        </div>
        <form className="mt-6 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="mb-6 text-red-500 text-sm text-center">{error}</div>
          )}
          <div className="shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Электронная почта
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="mb-6 appearance-none rounded-3xl relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
                placeholder="Электронная почта"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Пароль
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-3xl relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 sm:text-sm"
                placeholder="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="mb-8 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-3xl text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Войти
            </button>
            <p className="text-center text-base font-light font-light text-gray-600">
                Новый пользователь? 
                <a className="pl-1 font-medium text-gray-600 hover:underline" href="/register">Создать аккаунт</a>
            </p>
            <p className="text-center text-base font-light font-light text-gray-600 mt-2">
                <a className="font-medium text-gray-600 hover:underline" href="/restore-password">Забыли пароль?</a>
            </p>
          </div>
        </form>
      </div>
    </article>
  );
} 